<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">2019-02-22</p>
    <div class="content">
      <!-- 第一段内容：核心信息（高亮） -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="highlightText(currentNews.content?.split('---')[0] || '')"></p>
        </div>
      </div>

    

      <!-- 第二段内容：大会细节 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[1] || ''"></p>
        </div>
      </div>

      <!-- 第三段内容：协议签订与工程细节 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[2] || ''"></p>
        </div>
      </div>

      <!-- 第四段内容：谢伟讲话 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[3] || ''"></p>
        </div>
      </div>

      <!-- 第五段内容：上海超导背景 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[4] || ''"></p>
        </div>
      </div>

      <!-- 第六段内容：上海超导项目经验与赵跃讲话 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[5] || ''"></p>
        </div>
      </div>

      <!-- 第七段内容：未来展望 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[6] || ''"></p>
        </div>
      </div>

    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 通过ID查找新闻
  const newsItem = newsList.find((news: any) => news.id === 'shoucidianlan');
  return newsItem || {};
});

// 处理高亮文本的函数
const highlightText = (text: string) => {
  return text.replace(/\[\[highlight\]\](.*?)\[\[\/highlight\]\]/g, '<span class="highlighted-text">$1</span>');
};
</script>

<style scoped lang="scss">
.page-container {
  overflow: auto;
}

.content-section {
  margin-bottom: 20px;
}

.text-block p {
  text-indent: 2em; /* First line indent */
  line-height: 1.8; /* Line height */
  margin-bottom: 1em; /* Paragraph spacing */
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
}

.image-container img {
  max-width: 80%; /* Adjust width as needed */
  height: auto; /* Maintain aspect ratio */
  border-radius: 4px;
}

.image-caption {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
}

:deep(.highlighted-text) {
  color: #0066cc;
  font-weight: bold;
  background-color: transparent;
  padding: 2px 4px;
  border-radius: 3px;
}
</style> 